import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'

import type AttendancePolicyForm from 'modules/attendance/lib/forms/AttendancePolicyForm'
import type AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'

const useUpdateAttendancePolicy = (
  policyForm: AttendancePolicyForm,
  attendancePolicy: AttendancePolicy
) => {
  const { running: loading, performAction: updatePolicy } = useAsyncAction(
    async () => {
      await policyForm.save(attendancePolicy, { patch: false })

      dispatch({
        type: EventTypes.TIMETRACKING_POLICY_UPDATED,
      })
    },
    { successFlash: true }
  )

  return {
    loading,
    updatePolicy,
  }
}

export default useUpdateAttendancePolicy
